/**
 * Runtime configuration, resolved at BUILD time from CRA environment variables
 * (REACT_APP_* are inlined by react-scripts and by the prerender bundle).
 *
 *   REACT_APP_ENV          development | staging | production  (default: development)
 *   REACT_APP_SITE_URL     public origin of this site, no trailing slash
 *                          (default per env: http://localhost:3000, https://stg.maplexxon.com, https://maplexxon.com)
 *   REACT_APP_SERVER_URL   API / socket server origin (default per env, see SERVER_URLS)
 *   REACT_APP_FB_PIXEL_ID  Facebook Pixel ID (only used when REACT_APP_ENV=production)
 */

const ENVIRONMENTS = ["development", "staging", "production"];

const rawEnv = (process.env.REACT_APP_ENV || "").trim().toLowerCase();

export const APP_ENV = ENVIRONMENTS.includes(rawEnv) ? rawEnv : "development";
export const IS_PRODUCTION = APP_ENV === "production";

const SERVER_URLS = {
  development: "http://localhost:4000",
  staging: "https://echostg.maplexxon.com",
  production: "https://echo.maplexxon.com",
};

const SITE_URLS = {
  development: "http://localhost:3000",
  staging: "https://stg.maplexxon.com",
  production: "https://maplexxon.com",
};

const stripTrailingSlash = (url) => url.trim().replace(/\/+$/, "");

export const SERVER_URL = stripTrailingSlash(process.env.REACT_APP_SERVER_URL || SERVER_URLS[APP_ENV]);
export const SITE_URL = stripTrailingSlash(process.env.REACT_APP_SITE_URL || SITE_URLS[APP_ENV]);

export const FB_PIXEL_ID = (process.env.REACT_APP_FB_PIXEL_ID || "1127237541078902").trim();

export const SITE_NAME = "Maplexxon";
